import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';

// Lazy loading de componentes
const Home = React.lazy(() => import('./pages/Home'));
const AdminLogin = React.lazy(() => import('./pages/AdminLogin'));
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const CuentasAlquiladas = React.lazy(() => import('./pages/CuentasAlquiladas'));
const CuentasDominio = React.lazy(() => import('./pages/CuentasDominio'));
const CuentasPerfiles = React.lazy(() => import('./pages/CuentasPerfiles'));

// Componente de carga
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-900">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
  </div>
);

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cuentas-alquiladas" element={<CuentasAlquiladas />} />
          <Route path="/cuentas-dominio" element={<CuentasDominio />} />
          <Route path="/cuentas-perfiles" element={<CuentasPerfiles />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;